import FormLayout from "src/layouts/FormLayout";
import {
  useResponseRedirect,
  useRedirectToPage,
  useRoleForBorrower,
} from "src/hooks";
import { useFormLoad } from "src/hooks/useFormLoad";
import { useDlaFormSubmit } from "src/hooks/useDlaFormSubmit";
import { useWebClientApi } from "src/api";
import { useAuth } from "src/context";
import {
  type CurrentAddressFormData,
  fromCoborrowerCurrentAddress,
  toCoborrowerConfirmationAddressReq,
} from "src/api/adapters/address";
import { Col } from "src/components/layout";
import AddressItem from "./AddressItem";
import type { DtoAddress } from "@porchpass/api-client";
import { useEffect } from "react";
import { FormTable, Location03Icon } from "@porchpass/ui";

export default () => {
  const role = useRoleForBorrower();
  const { user: firebaseUser } = useAuth();
  const api = useWebClientApi();
  const { formData } = useFormLoad<CurrentAddressFormData>(
    {},
    () => api.getCurrentAddress(),
    (data) =>
      fromCoborrowerCurrentAddress(
        data as Parameters<typeof fromCoborrowerCurrentAddress>[0],
      ),
    { enabled: !!firebaseUser },
  );
  const [submitHandler, _loading, response] = useDlaFormSubmit(
    (data: CurrentAddressFormData) =>
      api.createAddress(toCoborrowerConfirmationAddressReq(data)),
  );
  useResponseRedirect("/address", response);
  const goToNextPage = useRedirectToPage("/address");

  useEffect(() => {
    if (
      "has_valid_current_address" in formData &&
      !formData.has_valid_current_address
    ) {
      goToNextPage();
    }
  }, [formData]);

  if (role === "BORROWER") {
    goToNextPage();
  }
  return (
    <FormLayout
      title="Is this your current address?"
      headerTitle="Address"
      stepIndex={2}
      footerTitle={"Yes"}
      clickHandler={() => void submitHandler(formData)}
      cancelHandler={() => goToNextPage()}
    >
      <Col>
        <FormTable
          title="Current Address"
          headerIcon={
            <Location03Icon
              variant="bulk-rounded"
              size={16}
              className="text-[#6F41E6]"
            />
          }
        >
          <AddressItem address={formData as DtoAddress} />
        </FormTable>
      </Col>
    </FormLayout>
  );
};
